import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=0164d6fa&scoped=true&"
import script from "./FormDialog.vue?vue&type=script&lang=ts&"
export * from "./FormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FormDialog.vue?vue&type=style&index=0&id=0164d6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164d6fa",
  null
  
)

export default component.exports